// extracted by mini-css-extract-plugin
module.exports = {"uploadOut":"patientAuth_uploadOut__3FoWw","fileName":"patientAuth_fileName__1lpkm","fileSize":"patientAuth_fileSize__3pRI0","uploadedfile":"patientAuth_uploadedfile__mZ7It"};